import QuestionForm from "./QuestionForm";
import { useContext } from "react";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import { useGetEvent } from "../../api/event";
import { Center, Loader } from "@mantine/core";
import { useCreateSurveyQuestion } from "../../api/survey";
import { useParams } from "react-router-dom";

function CreateQuestion() {
  const { user } = useContext(AuthContext);
  const workspace = getCurrentWorkspace(user);
  const { data: event, isPending } = useGetEvent(workspace.eventId);

  const { id: surveyId } = useParams();
  const createQuestion = useCreateSurveyQuestion(surveyId);

  const handleSubmit = (payload, { reset, getDefaultValues }) => {
    createQuestion.mutate(payload, {
      onSuccess: () => {
        reset(getDefaultValues());
      },
    });
  };

  if (isPending)
    return (
      <Center>
        <Loader />
      </Center>
    );

  return <QuestionForm event={event} onSubmit={handleSubmit} />;
}

export default CreateQuestion;
